<template>
  <b-form-group :id="id">
    <div class="row justify-content-center">
      <div class="col-12 col-sm-6">
        <b-form-checkbox
          v-for="(option, index) in options"
          v-if="index < breakpoint"
          :key="option.value"
          :value="option.value"
          v-model="selected"
          @change="optionSelected"
        >
          {{ option.text }}
        </b-form-checkbox>
      </div>
      <div class="col-12 col-sm-6">
        <b-form-checkbox
          v-for="(option, index) in options"
          v-if="index >= breakpoint"
          :key="option.value"
          :value="option.value"
          v-model="selected"
          @change="optionSelected"
        >
          {{ option.text }}
        </b-form-checkbox>
      </div>
    </div>
    <!--<b-form-checkbox-group
            v-model="selected"
            :options="options"
            @change="optionSelected"
        ></b-form-checkbox-group>-->
  </b-form-group>
</template>

<script>
export default {
  name: "CheckboxPrompt",
  props: {
    id: String,
    answers: Array,
    userAnswers: Array,
  },
  data() {
    return {
      selected: this.userAnswers,
    };
  },
  methods: {
    optionSelected() {
      setTimeout(() => {
        this.$emit("optionSelected", { answers: this.selected });
      }, 100);
    },
  },
  computed: {
    options() {
      return this.answers.map((answer) => {
        return { text: answer.text, value: answer.id };
      });
    },
    breakpoint() {
      return Math.ceil(this.answers.length / 2);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .custom-checkbox {
  .custom-control-input {
    &:focus ~ .custom-control-label::before {
      box-shadow: 0 0 0 0.2rem rgba($color-orange, 0.2);
    }

    &:checked ~ .custom-control-label::after {
      background-color: $color-orange;
      border-radius: 4px;
    }
  }
}
</style>
